import { render, staticRenderFns } from "./DriversVehicleInspectionMonthsCreate.vue?vue&type=template&id=23fcd795&"
import script from "./DriversVehicleInspectionMonthsCreate.vue?vue&type=script&lang=js&"
export * from "./DriversVehicleInspectionMonthsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports